export enum TechnologyActionTypeEnum { 
    SetTechnologyCounts = "SET_TECHNOLOGY_COUNTS"
}